export default {
  allDay: 'All day',
};
